module.exports = __webpack_public_path__ + "img/logo-footer.e2c25f18.png";